import { createSlice } from "@reduxjs/toolkit";
import { fetchUsers } from "./operations";

export const selectUsers = state => state.users.items;

const usersSlice = createSlice({
 name: "users",
 initialState: {
    items: [],
    loading: false,
    error: false,
 },
 extraReducers: builder => {
   builder
    .addCase(fetchUsers.pending, (state) => {
        state.loading = true;
    })
    .addCase(fetchUsers.fulfilled, (state, action) => {
        state.loading = false;
        state.error = false;
        state.items = action.payload;
    })
    .addCase(fetchUsers.rejected, (state) => {
        state.loading = false;
        state.error = true;
    })
},
});

export default usersSlice.reducer;